// AES-256-GCM localStorage encryption — Web Crypto API, no external dependencies
// Key is derived per-user via PBKDF2 so cached data is tied to the authenticated session.

const _toB64 = buf => btoa(String.fromCharCode(...new Uint8Array(buf)))
const _fromB64 = b64 => Uint8Array.from(atob(b64), c => c.charCodeAt(0))

export async function lsDeriveKey(userId) {
  const raw = new TextEncoder().encode(userId + '|blessedops|2026')
  const keyMaterial = await crypto.subtle.importKey('raw', raw, 'PBKDF2', false, ['deriveKey'])
  return crypto.subtle.deriveKey(
    { name: 'PBKDF2', salt: new TextEncoder().encode('bops_ls_salt_v1'), iterations: 100000, hash: 'SHA-256' },
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  )
}

export async function lsEncrypt(cryptoKey, data) {
  const iv = crypto.getRandomValues(new Uint8Array(12))
  const encrypted = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    cryptoKey,
    new TextEncoder().encode(JSON.stringify(data))
  )
  return _toB64(iv.buffer) + '.' + _toB64(encrypted)
}

export async function lsDecrypt(cryptoKey, ciphertext) {
  const [ivB64, dataB64] = ciphertext.split('.')
  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: _fromB64(ivB64) },
    cryptoKey,
    _fromB64(dataB64)
  )
  return JSON.parse(new TextDecoder().decode(decrypted))
}
